import { SET_TASK_SELECTED, SET_TASK_DETAIL_DATA, SET_TASK_DETAIL_LOADING } from "../../../actions";

export const taskSelected = ( state = {}, action) => {
    switch(action.type) {
        case SET_TASK_SELECTED: {
            const { taskSelected } = action.payload;
            return {...state, data: taskSelected};
        }
        case SET_TASK_DETAIL_DATA: {
            const { detail } = action.payload;
            return { ...state, loading: false, detail }
        }
        case SET_TASK_DETAIL_LOADING: {
            return { ...state, loading: true }
        }
        default:
            return state
    }
}